import { create } from 'zustand';
import type { ServerMessage, WorldPublic } from '@jetopolis/shared';
import type { ConnectionState, WorldSocket } from '../ws/client';

interface WorldState {
  world: WorldPublic | null;
  online: number;
  nextTickAt: number | null;
  connection: ConnectionState;
  /** Номер последнего применённого тика: защита от прихода устаревшего пуша. */
  lastSeq: number;
  socket: WorldSocket | null;

  setSocket: (socket: WorldSocket | null) => void;
  setConnection: (state: ConnectionState) => void;
  applyMessage: (msg: ServerMessage) => void;
  hydrate: (world: WorldPublic, online: number, nextTickAt: number | null) => void;
  reset: () => void;
}

export const useWorld = create<WorldState>((set, get) => ({
  world: null,
  online: 0,
  nextTickAt: null,
  connection: 'connecting',
  lastSeq: 0,
  socket: null,

  setSocket: (socket) => {
    set({ socket });
  },
  setConnection: (connection) => {
    set({ connection });
  },

  hydrate: (world, online, nextTickAt) => {
    set({ world, online, nextTickAt });
  },

  applyMessage: (msg) => {
    if (!('t' in msg)) {
      // Ответ на команду: world.join приносит полное состояние мира.
      if (msg.ok && typeof msg.result === 'object' && msg.result !== null) {
        const r = msg.result as {
          world?: WorldPublic;
          online?: number;
          nextTickAt?: number | null;
        };
        if (r.world) {
          set({ world: r.world, online: r.online ?? 0, nextTickAt: r.nextTickAt ?? null });
        }
      }
      return;
    }

    switch (msg.t) {
      case 'world.day': {
        // Пуш старее применённого игнорируем: переподключение может принести
        // отложенное сообщение, и дата не должна прыгать назад.
        if (msg.payload.seq <= get().lastSeq) return;
        const current = get().world;
        set({
          lastSeq: msg.payload.seq,
          nextTickAt: msg.payload.nextTickAt,
          world: current
            ? { ...current, gameDate: msg.payload.gameDate, status: msg.payload.status }
            : current,
        });
        return;
      }
      case 'tick.eta': {
        const current = get().world;
        set({
          nextTickAt: msg.nextTickAt,
          world: current ? { ...current, gameDate: msg.gameDate } : current,
        });
        return;
      }
      case 'presence': {
        set({ online: msg.online });
        return;
      }
      case 'error': {
        console.error('[ws] ошибка протокола', msg.code, msg.params);
        return;
      }
    }
  },

  reset: () => {
    set({ world: null, online: 0, nextTickAt: null, lastSeq: 0, connection: 'connecting' });
  },
}));
